<template lang="pug">
  el-select(v-model='internalValue' filterable @change='onChange')
    el-option-group(v-for='tz in timezones' :key='tz.label' :label='tz.label')
      el-option(v-for='tzName in tz.options' :key='tzName' :label='tzName' :value='tzName')

</template>

<script>
import _ from "lodash";
import moment from "moment-timezone";

const timezones = _.map(
  _.omit(
    _.groupBy(moment.tz.names(), tzName =>
      tzName.indexOf("/") > -1 ? tzName.split("/")[0] : "General"
    ),
    ["General", "Antarctica", "Etc", "Pacific"]
  ),
  (tzNames, groupName) => ({
    label: groupName,
    options: tzNames
  })
);

export default {
  props: ["value", "initialValue"],
  watch: {
    value(newVal) {
      this.internalValue = newVal;
    }
  },
  data() {
    return {
      internalValue: this.value,
      timezones
    };
  },
  methods: {
    onChange(value) {
      this.$emit("input", value);
    }
  },
  mounted() {
    if (this.initialValue && !this.value) {
      this.internalValue = this.initialValue;
    }
  }
};
</script>

<style scoped lang="scss"></style>
